import { Availabilities, Reservation } from "../types/entities";
import { API_URLS } from "constants/apiConstants";
import { ApiClient, ApiResponse, PagedResponse } from "./requestExecutor";

export class ReservationApi extends ApiClient {
	public findTable = async (
		reservation: Reservation,
		serviceId: string,
		mappedSchedules: string[]
	): Promise<ApiResponse<Availabilities>> => {
		const date = new Date(reservation.time!);
		const utcDate = new Date(
			Date.UTC(
				date.getFullYear(),
				date.getMonth(),
				date.getDate(),
				date.getHours(),
				date.getMinutes(),
				date.getSeconds()
			)
		);
		const data = {
			date: utcDate.toISOString(), // Convertir a ISO string en UTC
			numberPeople: reservation.numberDiners,
			serviceId: serviceId,
			mappedSchedules: mappedSchedules.map((s) => s.concat(":00")),
		};
		return this.post<Availabilities>(
			API_URLS.reservation.findTableUrl,
			JSON.stringify(data),
			{ contentType: "application/json" }
		);
	};

	public createReservation = async (
		reservation: Reservation
	): Promise<ApiResponse<Reservation>> => {
		try {
			const date = new Date(reservation.time!);
			const utcDate = new Date(
				Date.UTC(
					date.getFullYear(),
					date.getMonth(),
					date.getDate(),
					date.getHours(),
					date.getMinutes(),
					date.getSeconds()
				)
			);
			const newReservation = {
				...reservation,
				time: utcDate,
				customer: undefined,
				customerId: reservation.customer.id!,
				service: undefined,
				serviceId: reservation.service!.id!,
			};
			if (reservation.time == null) {
				console.error("No se ha ingresado una fecha.");
				throw new Error("No se ha ingresado una fecha.");
			}
			return this.post<Reservation>(
				API_URLS.reservation.saveUrl,
				JSON.stringify(newReservation)
			);
		} catch (error) {
			console.error("Error al crear la reserva.", error);
			throw error;
		}
	};

	public cancelReservation = async (
		id: string
	): Promise<ApiResponse<Reservation>> => {
		try {
			return this.put<Reservation>(
				API_URLS.reservation.cancelUrl.replace("{id}", id),
				{}
			);
		} catch (error) {
			console.error("Error al cancelar la reserva.", error);
			throw error;
		}
	};

	public getCustomerReservations = async (
		id: string,
		size: number,
		page: number
	): Promise<ApiResponse<PagedResponse<Reservation>>> => {
		try {
			return this.get<PagedResponse<Reservation>>(
				API_URLS.reservation.getByCustomerUrl.replace("{id}", id) +
					`?page=${page}&size=${size}`
			);
		} catch (error) {
			console.error("Error al obtener las reservas del cliente:", error);
			throw error;
		}
	};

	public getReservationByPayment = async (
		id: string
	): Promise<ApiResponse<Reservation>> => {
		try {
			return this.get<Reservation>(
				API_URLS.reservation.getByPaymentUrl.replace("{id}", id)
			);
		} catch (error) {
			console.error("Error al obtener la reserva para ese payment:", error);
			throw error;
		}
	};
}
